const imgMap: Record<string, any> = {};

// 统一按 URL 方式收集静态资源，避免 svg 被按模块导入后触发 ?import 异常
const files = import.meta.glob('./*/*', {
  eager: true,
  import: 'default',
  query: '?url',
}) as Record<string, string>;

for (const key in files) {
  if (Object.prototype.hasOwnProperty.call(files, key)) {
    if (key.endsWith('.html')) {
      continue;
    }

    const name = key.split(/[/.]/).filter(Boolean);

    if (name.length >= 3) {
      if (!imgMap[name[0]]) {
        imgMap[name[0]] = {};
      }

      imgMap[name[0]][name[1]] = files[key];
    }
  }
}

export const { img } = imgMap;
export const { icon } = imgMap;
